/**
 * Bro-Mon — Browser Monsters web-surf game
 *
 * Declares one web-accessible-resource group — `assets/images/*`, `assets/fonts/*` and
 * three named stylesheets — matched to every origin with no `use_dynamic_url`. The image
 * and font filenames carry webpack content-hash suffixes, so we probe the three stable
 * vendor-named stylesheets instead; each is reachable from any page at a fixed URL that
 * carries the extension ID, making a successful fetch conclusive.
 *
 * Manifest verified against version 3.0.6.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'oedkbkpngfmjfbmmmijkogojlcddmcgf';

export const broMon: ExtensionDefinition = {
  id: ID,
  name: 'Bro-Mon 🐾 Browser Monsters - Web Surf Game',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 30_000,
  notes:
    'Images and fonts are content-hashed, but three named stylesheets (battle_app.css, ' +
    'portals_script.css, content_script.css) are exposed to every origin and stable.',
  signals: [
    {
      id: 'war-battle-app-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch battle_app.css — a vendor-named stylesheet exposed to every origin, present ' +
        'only when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'battle_app.css'),
    },
    {
      id: 'war-portals-script-css',
      kind: 'web-accessible-resource',
      description: 'Fetch portals_script.css — a second named stylesheet, corroborating.',
      weight: 0.5,
      run: () => probeFetch(ID, 'portals_script.css'),
    },
    {
      id: 'war-content-script-css',
      kind: 'web-accessible-resource',
      description: 'Fetch content_script.css — a third independent named stylesheet.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content_script.css'),
    },
  ],
};
